import React, { Component } from "react";
import classnames from "classnames";
import ReactTable from "react-table";
import PaginationComponent from "./PaginationComponent";
import "./custom.css";
import { Link, Route } from "react-router-dom";
import { languageService } from "../../../Language/language.service";
import PropTypes from "prop-types";
import { thisTableStyle } from "./style/index";
import { themeService } from "theme/service/activeTheme.service";
import Radium from "radium";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import TooltipContainer from "../../../libraries/TooltipContainer";
import _ from "lodash";
class ThisTable extends Component {
  constructor(props) {
    super(props);
    this.tableWrapRef = React.createRef();
    this.topScrollRef = React.createRef();
    let columnStyle = this.props.onColClick
      ? {
          getHeaderProps: (state, rowInfo, col, instance) => {
            return {
              onClick: () => {
                this.props.onColClick(state, rowInfo, col, instance);
              },
              style: {
                ...themeService(thisTableStyle.HeaderPropsStyle),
              },
            };
          },
        }
      : {
          getHeaderProps: () => {
            return {
              style: { ...themeService(thisTableStyle.HeaderPropsStyle) },
            };
          },
        };
    this.state = {
      columns: [],
      columnStyle: columnStyle,
      selected: null,
      page: 0,
      mystate: false,
    };
    this.createTableColumnsWithFilters = this.createTableColumnsWithFilters.bind(this);
  }
  componentDidMount() {
    this.updateColumns(this.createTableColumnsWithFilters());
    if (this.props.page) {
      this.setState({ page: this.props.page });
    }
    this.syncWidth();
  }

  syncWidth = () => {
    if (this.tableWrapRef.current && this.topScrollRef.current) {
      const rtTable = this.tableWrapRef.current.querySelector(".rt-table");
      if (rtTable) this.topScrollRef.current.firstElementChild.style.width = rtTable.scrollWidth + "px";
    }
  };

  updateColumns(newTableColms) {
    let columns = [];
    const { columnStyle } = this.state;
    let receivedColumns = newTableColms;
    receivedColumns.forEach((column) => {
      if (column.applicationType && this.props.applicationType && !column.applicationType.includes(this.props.applicationType)) return;
      let copyColumnStyle = { ...columnStyle };
      let columnKeys = Object.keys(column);
      columnKeys.forEach((key) => {
        copyColumnStyle[key] = column[key];
      });
      columns.push(copyColumnStyle);
    });
    this.setState({
      columns: columns,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page && (this.props.page !== undefined || this.props.page !== null)) {
      this.setState({ page: this.props.page });
    }

    if (!_.isEqual(prevProps.tableData, this.props.tableData)) {
      this.updateColumns(this.createTableColumnsWithFilters());
    }
    if (!_.isEqual(prevProps.tableColumns, this.props.tableColumns)) {
      this.updateColumns(this.createTableColumnsWithFilters());
    }
    this.syncWidth();
  }
  createTableColumnsWithFilters() {
    if (!this.props.showFilters) return this.props.tableColumns;
    const { tableData } = this.props;
    const tableColumns = _.cloneDeep(this.props.tableColumns);
    let tableWithFilterDropdown = tableColumns.map((tc) => {
      if (tc.searchType && tc.searchType === "dropDown") {
        const dataSet = [...new Set((tableData && tableData.length > 0 && tableData.map((m) => tc.accessor(m))) || [])].sort();
        tc.Filter = ({ filter, onChange }) => {
          return (
            <select
              style={{ height: "min-content", width: "100%" }}
              value={filter && dataSet.includes(filter.value) ? filter.value : ""}
              onChange={(e) => onChange(e.target.value)}
            >
              <option value="">All</option>
              {dataSet.map((data) => (
                <option key={data} value={data}>
                  {data}
                </option>
              ))}
            </select>
          );
        };

        tc.filterMethod = (filter, row) => {
          let value = filter && dataSet.includes(filter.value) ? filter.value : "";
          return value === "" || row[filter.id] === value;
        };
      }
      return tc;
    });
    return tableWithFilterDropdown;
  }
  render() {
    const { pagination, pageSize, tableData } = this.props;
    let resolvedPageSize = 15;
    if (!pagination) {
      Array.isArray(tableData) && (resolvedPageSize = tableData.length);
    } else if (pageSize) {
      resolvedPageSize = pageSize;
    }
    return (
      <div
        style={{
          ...themeService(thisTableStyle.outerStyle),
          overflowY: this.props.classNameCustom == "fillFullHeight" ? "none" : "auto",
        }}
        className={this.props.classNameCustom}
        ref={this.tableWrapRef}
      >
        <div 
          ref={this.topScrollRef}
          className= "scrollbarHor"
          style={{ overflowX: 'auto', overflowY: 'hidden', width: '100%', marginBottom: '2px' }}
          onScroll={(e) => {
            if (this.tableWrapRef.current) {
               const rtTable = this.tableWrapRef.current.querySelector('.rt-table');
               if (rtTable && rtTable.scrollLeft !== e.target.scrollLeft) {
                 rtTable.scrollLeft = e.target.scrollLeft;
               }
            }
          }}
        >
          <div style={{ height: '1px', width: '100%' }}></div>
        </div>
        <ReactTable
          key={"reactTable"}
          filtered={this.props.tableFilters}
          defaultSorted={this.props.defaultSorted}
          previousText={languageService("previous")}
          nextText={languageService("next")}
          loadingText={languageService("Loading...")}
          noDataText={languageService("No rows found")}
          pageText={languageService("Page")}
          ofText={languageService("of")}
          rowsText={languageService("rows")}
          pageJumpText={languageService("jump to page")}
          rowsSelectorText={languageService("rows per page")}
          sortable={this.props.sortable}
          data={this.props.tableData}
          columns={this.state.columns}
          showPagination={pagination}
          pageSize={resolvedPageSize}
          manual={this.props.manual}
          defaultPageSize={resolvedPageSize}
          pages={this.props.pages}
          filterable={this.props.showFilters}
          showPaginationTop={this.props.showPaginationTop || false}
          showPaginationBottom={this.props.showPaginationBottom || true}
          pageSizeOptions={this.props.pageSizeOptions || [5, 10, 20, 25, 50, 100]}
          onPageChange={(page) => {
            if (this.props.handlePageChange) {
              this.props.handlePageChange(page);
            } else {
              this.setState({
                page: page,
              });
            }
          }}
          page={this.state.page}
          minRows={this.props.minRows ? this.props.minRows : 1}
          style={{ ...themeService(thisTableStyle.tableStyle), height: this.props.height ? this.props.height : "inherit" }}
          getTbodyProps={(state, rowInfo, column, instance) => {
            return {
              className: "scrollbar issue",
            };
          }}
          getTrProps={(state, rowInfo, column, instance) => {
            let indexRow = null;
            let selected = "No Selected";
            if (rowInfo) {
              indexRow = rowInfo.index;
              if (rowInfo.original.selected == true) {
                selected = rowInfo.index;
              }
            }
            return {
              onClick: (e) => {
                //console.log(this.state.selected);
                let val = indexRow;
                this.state.selected == indexRow && (val = null);
                this.setState({
                  selected: val,
                });

                if (this.props.onClickSelect) {
                  this.props.handleSelectedClick && this.props.handleSelectedClick(e, rowInfo);
                }
              },

              style: themeService(thisTableStyle.rowStyle(indexRow, this.state, this.props, rowInfo)),
            };
          }}
          getTrGroupProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                borderBottom: "1px solid rgb(227, 233, 239)",
              },
            };
          }}
          getTableProps={(state, rowInfo, column, instance) => {
            const { updateResolvedData } = this.props;
            updateResolvedData && updateResolvedData(state.resolvedData, state.columns);
            return {
              className: "scrollbarHor",
              onScroll: (e) => {
                 if (this.topScrollRef.current && this.topScrollRef.current.scrollLeft !== e.target.scrollLeft) {
                     this.topScrollRef.current.scrollLeft = e.target.scrollLeft;
                 }
              }
            };
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: themeService(thisTableStyle.cellStyle),
            };
          }}
          showPageJump={false}
          PaginationComponent={PaginationComponent}
          onSortedChange={this.props.onSortedChange}
          onFetchData={this.props.fetchData}
          onFilteredChange={(filtered, column) => {
            if (this.props.handleTableFiltersChange) {
              this.props.handleTableFiltersChange(filtered);
            }
            if (filtered && filtered.length == 0) {
              this.setState({ page: this.props.sortedData }); // Reset page to 0 when filters are applied
            } else {
              this.setState({ page: this.props.sortedData });
            }
          }}
          defaultFilterMethod={(filter, row, column) => {
            const id = filter.pivotId || filter.id;
            // const rowValue = row[id] !== undefined ? String(row[id]).toLowerCase().replace(/\s+/g, '') : '';
            // const filterValue = filter.value.toLowerCase().replace(/\s+/g, '');
            const rowValue = row[id] !== undefined ? String(row[id]).toLowerCase().trim() : "";
            const filterValue = filter.value.toLowerCase().trim();
            this.setState({ page: 0 });
            return rowValue == filterValue || rowValue.includes(filterValue);
          }}
          getTheadFilterThProps={(state, rowInfo, column, instance) =>
            column.filterable !== false && {
              title: `Search: ${column.Header}`,
            }
          }
        />
        {this.props.forDashboard && (
          <Link
            to={this.props.fromDashboardToLink ? this.props.fromDashboardToLink : "#"}
            style={themeService(thisTableStyle.detailBtnStyle)}
          >
            {languageService("View Details")}
          </Link>
        )}
      </div>
    );
  }
}

export default Radium(ThisTable);

ThisTable.defaultProps = {
  sortable: true,
};



// WEBPACK FOOTER //
// ./src/components/Common/ThisTable/index.jsx